// extracted by mini-css-extract-plugin
export default {"location-selector":"header_location-selector__Wc7bk"};